import { defineComponent as _defineComponent } from 'vue'
import { Device } from '@/models/device';
import { LayoutSlot } from '@/views/dashboard/layout-grid';
import LayoutGrid from '@/views/dashboard/LayoutGrid.vue';
import HealthIndicators from '@/components/careConsole/overview/HealthIndicators.vue';
import ModuleEventsIndicators from '@/components/careConsole/overview/ModuleEventsIndicators.vue';
import DeviceCard from '@/components/careConsole/overview/DeviceCard.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'Overview',
  props: {
    dateRange: null,
    device: null
  },
  setup(__props: any) {



const layout: LayoutSlot[] = [
  { column: 0, row: 0, width: 4, height: 8 },
  { column: 4, row: 0, width: 4, height: 8 },
  { column: 8, row: 0, width: 4, height: 8 },
];

return { __sfc: true,layout, LayoutGrid, HealthIndicators, ModuleEventsIndicators, DeviceCard }
}

})